import React from 'react';
import { VisuallyHidden } from '@zillow/constellation';
import PropTypes from 'prop-types';

var ChartDescription = function ChartDescription(_ref) {
  var name = _ref.name,
    xLabel = _ref.xLabel,
    yLabel = _ref.yLabel,
    xFormatter = _ref.xFormatter,
    yFormatter = _ref.yFormatter,
    dataPoints = _ref.dataPoints;
  var dataPointsToCommunicate = dataPoints.filter(function (point, index) {
    if (index === 0) {
      return true;
    }
    if (point.info) {
      return true;
    }
    if (index === dataPoints.length - 1) {
      return true;
    }
    return false;
  });
  return /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement("table", {
    "aria-label": name
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, xLabel), /*#__PURE__*/React.createElement("th", null, yLabel), /*#__PURE__*/React.createElement("th", null, "Comments"))), /*#__PURE__*/React.createElement("tbody", null, dataPointsToCommunicate.map(function (_ref2) {
    var x = _ref2.x,
      y = _ref2.y,
      info = _ref2.info;
    return /*#__PURE__*/React.createElement("tr", {
      key: x + "," + y
    }, /*#__PURE__*/React.createElement("td", null, xFormatter ? xFormatter(x) : x), /*#__PURE__*/React.createElement("td", null, yFormatter ? yFormatter(y) : y), /*#__PURE__*/React.createElement("td", null, info));
  }))));
};
ChartDescription.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  xLabel: PropTypes.string.isRequired,
  yLabel: PropTypes.string.isRequired,
  xFormatter: PropTypes.func,
  yFormatter: PropTypes.func,
  dataPoints: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    info: PropTypes.string
  }))
} : {};
var ChartDescription$1 = ChartDescription;

export { ChartDescription$1 as default };
